export const CH_NFTS_TOTAL_COUNT = 6000;
export const CH_NFT_WHITELIST_PRICE = 0.2;
export const CH_NFT_PRICE = 0.25;
export const CH_MAX_ALLOWED_NFT_PUBLIC_SALE = 10;
export const CH_MAX_ALLOWED_NFT_WHITELIST = 6;
